import "@babel/polyfill";
import Vue from "vue";
import VueAxios from "vue-axios";
import moment from "moment";
import VueMomentLib from "vue-moment-lib";
import "./plugins/vuetify";

import App from "./App.vue";
import axios from "@/axios";
import { default as Axios } from "axios";
import router from "@/router";
import store from "@/store";

import lookupSelect from "@/components/lib/lookups/select-box";
import ethnicitySelector from "./components/people/ethnicity-selector";
import deleteItemButton from "@/components/lib/delete-item-button";
import editResourceButton from "@/components/lib/edit-resource-button";
import datePicker from "@/components/lib/date-picker";
import errorMessages from "@/components/lib/error-messages";

// import {
//   default as Adal,
//   AxiosAuthHttp,
//   AuthenticationContext
// } from "vue-adal";

moment.locale("en-nz");

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(VueMomentLib, { moment });

/*
Vue.use(Adal, {
  // This config gets passed along to Adal, so all settings available to adal can be used here.
  config: {
    // 'common' (multi-tenant gateway) or Azure AD Tenant ID
    // tenant: "common",
    tenant: "6cb0d10f-df64-4661-a4a6-f26e1b25c409", //dev

    // Application ID
    clientId: "6c60509d-b008-4bd5-b822-2022a177c4a9",

    // Host URI
    redirectUri: "http://localhost:8080",
    // redirectUri: "<host addr>",

    cacheLocation: "localStorage"
  },

  // Set this to true for authentication on startup
  requireAuthOnInitialize: true,

  // Pass a vue-router object in to add route hooks with authentication and role checking
  router: router
});

Vue.use({
  install(vue, opts = {}) {
    // if (!AuthenticationContext.isAuthenticated) {
    //   return;
    // }
    var graphApiBase = "https://graph.microsoft.com/v1.0";
    var graphAPIResource = "https://graph.microsoft.com";
    // Configures an axios http client with a interceptor to auto-acquire tokens
    vue.prototype.$graphApi = AxiosAuthHttp.createNewClient({
      // Required Params
      axios: Axios,
      resourceId: graphAPIResource, // Resource id to get a token against
      // resourceId: "https://graph.microsoft.com", // Resource id to get a token against

      // Optional Params
      router: router, // Enables a router hook to auto-acquire a token for the specific resource

      baseUrl: graphApiBase, // Base url to configure the client with
      // baseUrl: "https://graph.microsoft.com/v1.0", // Base url to configure the client with

      onTokenSuccess(http, context, token) {
        // Token success hook
        // When an attempt to retrieve a token is successful, this will get called.
        // This enables modification of the client after a successful call.
        if (context.user) {
          // Setup the client to talk with the Microsoft Graph API
          // http.defaults.baseURL = `${graphApiBase}/${context.user.profile.tid}`;
          http.defaults.baseURL = `${graphApiBase}`;
        }
      },

      onTokenFailure(error) {
        // Token failure hook
        // When an attempt to retrieve a token is not successful, this will get called.
        console.log(error);
      }
    });
  }
});
/** */

Vue.filter("formatDate", function(date, format) {
  if (!date) return date;
  if (!format) {
    // let theDate = new moment(date);
    // let nowDate = new moment();
    // var diff = theDate.diff(nowDate);
    // return moment.duration(diff).humanize(true);
    return moment(date).calendar();
  } else {
    return moment(date).format(format);
  }
});

Vue.component("lookup-select", lookupSelect);
Vue.component("ethnicity-selector", ethnicitySelector);
Vue.component("delete-item-button", deleteItemButton);
Vue.component("edit-resource-button", editResourceButton);
Vue.component("date-picker", datePicker);
Vue.component("error-messages", errorMessages);

export default Vue;

document.title = process.env.VUE_APP_TITLE;
